<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Provision
    .sub-headline Hier können Sie den Wert der Standard und ET-Provision manipulieren.

    b-message.margin-top(title="Sie sollten wissen, was Sie tun" type="is-danger" has-icon :closable="false")
      |Diese Einstellungen werden in der Regel einmalig oder in Absprache mit dem Systemadminstrator durchgeführt.
      br
      |Eine Veränderung der Daten führt zu einer sofortigen Veränderung in den Eigentümerabrechnungen.

    .rent-object-features-wrapper.margin-top
      .form.w-400.margin-top(v-for="commission, idx in commissions")
        ValidationObserver(v-slot="{ handleSubmit }", ref="form")
          ValidationProvider(
            name="Name",
            rules="required|min:2",
            v-slot="{ errors, valid }")
            b-field(
              label="Name",
              label-position="on-border",
              :type="{ 'is-danger': errors[0], 'is-success': valid }",
              :message="errors")
              b-input(v-model="commission.name" disabled)
          ValidationProvider(
            name="Beschreibung",
            rules="required|min:8",
            v-slot="{ errors, valid }")
            b-field(
              label="Beschreibung",
              label-position="on-border",
              :type="{ 'is-danger': errors[0], 'is-success': valid }",
              :message="errors")
              b-input(
                v-model="commission.description",
                maxlength="200",
                type="textarea"
                disabled)

          b-field(grouped)
            ValidationProvider(
              name="Provision in Prozent",
              rules="required",
              v-slot="{ errors, valid }")
              b-field(
                label="Provision in Prozent",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors")
                b-input(v-model="commission.commissionPercentage" numeric)
            .spacer.sm
            ValidationProvider(
              name="Steuersatz in Prozent",
              rules="required",
              v-slot="{ errors, valid }")
              b-field(
                label="Steuersatz in Prozent",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors")
                b-input(v-model="commission.taxPercentage" numeric)
                
          .button-wrapper.margin-top.right
            b-button(
              type="is-light",
              @click="$router.push({ name: 'SettingsOverview' })") Abbrechen
            b-button(
              type="is-primary",
              @click="handleSubmit(updateCommissions(idx))") Speichern
</template>

<script>
export default {
  data() {
    return {
      commissions: []
    };
  },
  methods: {
    updateCommissions(i) {
      this.$store.dispatch("commissions/update", this.commissions[i]);
    }
  },
  async mounted() {
    this.commissions = await this.$store.dispatch("commissions/findAll");
  },
};
</script>

<style lang="scss" scoped>
</style>